import { create } from 'zustand';

const useOrderDelivered = create((set) => ({
  schedularDate: {},
  selectedStatus: "ALL",
   
  setSchedularDate: (val) => set({ schedularDate: val }),
  setSelectedStatus: (val) => set({ selectedStatus: val }),

  homeDeliveryValue: false,
  setHomeDeliveryValue: (call) => set({ homeDeliveryValue: call }),
  urgentDeliveryValue: false,
  setUrgentDeliveryValue: (call) => set({ urgentDeliveryValue: call }),

}));
export default useOrderDelivered;
